import Amplify from "aws-amplify";
import { createRoot } from 'react-dom/client';
import App from './App';
import stack from './aws-exports.json';


const renderApp = () => {
    const tenant = stack['tenant'];
    const ws = stack['EDPlatformWS'];
    const Cognito = stack['EDPlatformCognito']
    const AppSync = stack['EDPlatformAppSync']
    const ApiGateway = stack['EDPlatformAPI']

    const config = {
        aws_project_region: "us-west-2",
        oauth: {
            domain: Cognito.Domain,
            scope: ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
            redirectSignIn: Cognito.RedirectSignIn,
            redirectSignOut: Cognito.RedirectSignOut,
            responseType: "code"
        },
        // Cognito
        aws_cognito_identity_pool_id: Cognito.IdentityPoolId,
        aws_cognito_region: Cognito.Region,
        aws_user_pools_id: Cognito.UserPoolId,
        aws_user_pools_web_client_id: Cognito.UserPoolClientId,
        // AppSync
        aws_appsync_graphqlEndpoint: AppSync.GraphQLEndpoint,
        aws_appsync_region: AppSync.Region,
        aws_appsync_authenticationType: AppSync.GraphQLAuthorizationType,
        aws_appsync_dangerously_connect_to_http_endpoint_for_testing: AppSync.DangerouslyConnectToHTTPEndpointForTesting,
        ...ApiGateway,
    }

    Amplify.configure(config)

    const script = document.createElement('script');
    script.defer = true;
    script.src = 'https://logs.capacitybeta.com/script.js';
    script.dataset.websiteId = stack["umami_id"];
    script.dataset.autoTrack = "false";
    document.head.appendChild(script);

    const epicClientID = stack["epic_physiohub_ui_client_id"];

    const container: any = document.getElementById('root');
    const root = createRoot(container);

    // 
    // ======================================================================================
    // START OF EHR LAUNCH DEMO
    // 
    // The following code block demonstrates how we would utilize Epic for an EHR 
    // launch and perform the OAuth 2.0 flow. However, for the initial phase of this 
    // software, we will store all of the relevant data within the AWS account.
    //

    // const getParamFromUrl = (param: string) => {
    //     const queryString = window.location.search;
    //     const queryParams = new URLSearchParams(queryString);
    //     return queryParams.get(param);
    // };

    // const redirectToAuthorizationServer = (authorizationUri: string) => {
    //     const redirectUri = encodeURIComponent("http://localhost:3000");
    //     const audUri = encodeURIComponent(baseUrl!);
    //     const state = ""; // Additional custom state that can be used by this app
    //     window.location.replace(`${authorizationUri}?scope=launch&response_type=code&redirect_uri=${redirectUri}&client_id=${EPIC_CLIENT_ID}&launch=${launchCode}&state=${state}&aud=${audUri}`);
    // };

    // const exchangeAuthorizationCodeForAccessToken = async (tokenUri: string, code: string) => {
    //     const redirectUri = encodeURIComponent("http://localhost:3000");
    //     const response = await fetch(tokenUri, {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/x-www-form-urlencoded",

    //         },
    //         body: `grant_type=authorization_code&code=${code}&client_id=${EPIC_CLIENT_ID}&redirect_uri=${redirectUri}`,
    //     });
    //     const json = await response.json();
    //     return json;
    // };

    // const getSmartConfiguration = async (returnUriType: string) => {
    //     // Get SMART configuration
    //     const baseUrl = sessionStorage.getItem("iss");
    //     const response = await fetch(`${baseUrl}/metadata`, {
    //         method: "GET",
    //         headers: {
    //             "Accept": "application/fhir+json",
    //             "Epic-Client-ID": EPIC_CLIENT_ID,
    //         },
    //     });
    //     const json = await response.json();

    //     // See https://appmarket.epic.com/Article/Index?docid=oauth2&section=Embedded-Oauth2-Launch_Initial-Launch
    //     const extensions = json["rest"][0]["security"]["extension"][0]["extension"];
    //     let authorizationUri = null;
    //     let tokenUri = null;
    //     for (const extension of extensions) {
    //         if (extension["url"] === "authorize") {
    //             authorizationUri = extension["valueUri"];
    //         }
    //         if (extension["url"] === "token") {
    //             tokenUri = extension["valueUri"];
    //         }
    //     }
    //     if (returnUriType === "authorize") {
    //         return authorizationUri;
    //     } else {
    //         return tokenUri;
    //     }
    // }

    // const baseUrl = getParamFromUrl("iss");
    // if (baseUrl) {
    //     sessionStorage.setItem("iss", baseUrl);
    // }

    // const launchCode = getParamFromUrl("launch");
    // const code = getParamFromUrl("code");
    // const state = getParamFromUrl("state");
    // if (baseUrl && launchCode) {
    //     // Initial launch from the EHR
    //     getSmartConfiguration("authorize").then((output: any) => {
    //         const authorizationUri = output;
    //         // Redirect to Epic for authorization
    //         redirectToAuthorizationServer(authorizationUri);
    //     }).catch((err: any) => {
    //         console.error(err);
    //         root.render(
    //             <div>Error fetching SMART configuration</div>
    //         );
    //     });
    // } else if (code) {
    //     // EHR authorization redirections back
    //     getSmartConfiguration("token").then((output: any) => {
    //         const authorizationUri = output;
    //         // Redirect to Epic to get access token
    //         exchangeAuthorizationCodeForAccessToken(authorizationUri, code).then((json: any) => {
    //             const accessToken = json.access_token;
    //             const patientId = json.patient;
    //             const encounter = json.encounter;
    //             const expiresIn = json.expires_in;
    //             console.log(json);
    //             root.render(
    //                 <div>Done! {accessToken}, {patientId}, {encounter}, {expiresIn}</div>
    //             );
    //         }).catch((err: any) => {
    //             console.error(err);
    //             root.render(
    //                 <div>Error fetching access token</div>
    //             );
    //         });
    //     }).catch((err: any) => {
    //         console.error(err);
    //         root.render(
    //             <div>Error fetching SMART configuration</div>
    //         );
    //     });
    // } else {
    //     // Invalid EHR redirect
    //     //
    //     // TODO: Still proceed with rest of the workflow, but user must
    //     // manually specify the patient MRN/CSN.
    //     root.render(
    //         <div>Not Launched from EHR</div>
    //     );
    // }

    //
    // END OF EHR LAUNCH DEMO
    // ======================================================================================

    root.render(
        <App tenant={tenant} ws={ws} epicClientID={epicClientID} />
        // <UserProvider>
        //     <App fhirClient={{}} />
        // </UserProvider>
    );
};

renderApp();
